import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useEffect, useState } from 'react';
import useInterval from '../../hooks/useInterval';
const TIMER = 10;
export const AnimatedNumber = forwardRef((props, ref) => {
    const { start, end, prefix = '', unit = '', speed = TIMER, decreasing = false, onEnd = () => { }, className = '' } = props, remainingProps = __rest(props, ["start", "end", "prefix", "unit", "speed", "decreasing", "onEnd", "className"]);
    const [value, setValue] = useState(start);
    const shallContinueRunning = decreasing ? value > end : value < end;
    useInterval(() => {
        setValue(currentValue => (decreasing ? currentValue - 1 : currentValue + 1));
    }, shallContinueRunning ? speed : null);
    useEffect(() => {
        if (!shallContinueRunning) {
            onEnd();
        }
    });
    return _jsx("span", Object.assign({ ref: ref }, remainingProps, { className: className }, { children: `${prefix}${value}${unit}` }));
});
export default AnimatedNumber;
